import { QuotePartNoteType } from 'quotes/enums';
import { IQuotePart, IRemoveQuotePartNotesByTypePayload } from 'quotes/types';

import { IQuotePartRemoveNotesForm } from './types';
import { getAvailableNoteTypes } from './utils';

// "All Types" has no backend sentinel: the selected types are always sent as explicit literals.
export const mapRemoveQuotePartNotesToServer = (
  quoteParts: IQuotePart[],
  data: IQuotePartRemoveNotesForm
): IRemoveQuotePartNotesByTypePayload => {
  // The form keeps dirty values across availability changes, so a type selected while it was still
  // offered can survive in the form state after the gate shrinks — only send what is available now.
  const availableNoteTypes = getAvailableNoteTypes(quoteParts);

  return {
    quotePartIds: (quoteParts || []).map((quotePart) => quotePart.id),
    noteTypes: Object.entries(data?.types || {})
      .filter(
        ([type, isSelected]) =>
          !!isSelected && availableNoteTypes.includes(type as QuotePartNoteType)
      )
      .map(([type]) => type as QuotePartNoteType),
  };
};
